/**
 * A module to track referrals from Google Ads and LinkedIn.
 * Stores referral Source and IDs and adds them to form submission if hidden referral tracking field exists.
 */

const REFERRER_ID_COOKIE = 'referrer-id'
const REFERRER_SOURCE_COOKIE = 'referrer-source'

const ReferrerTracker = {
  init: async () => {
    try {
      // check if we have a google ad or linkedin referrer id in the url
      // set the referrer id and source in the cookie store if a referrer exists
      const params = new URLSearchParams(window.location.search)
      const referrer = params.get('gclid') || params.get('li_fat_id')
      if (referrer) {
        //we're currently only tracking google ads and linkedin
        const source = params.get('gclid') ? 'Google Ads' : 'LinkedIn'

        await cookieStore.set(REFERRER_ID_COOKIE, referrer)
        await cookieStore.set(REFERRER_SOURCE_COOKIE, source)
      }
      // Get the referral Id & source from the cookie store if it exists.
      // If the page has the hidden referrer fields,
      // inject the values into the fields
      const referralId = await cookieStore.get(REFERRER_ID_COOKIE)
      const referralSource = await cookieStore.get(REFERRER_SOURCE_COOKIE)

      const referrerIdField = document.querySelector('.js-hidden-referral-id')
      const referrerSourceField = document.querySelector('.js-hidden-referral-source')

      if (referralId?.value && referrerIdField) {
        referrerIdField.value = referralId.value
      }
      if (referralSource?.value && referrerSourceField) {
        referrerSourceField.value = referralSource.value
      }
    } catch (error) {
      console.error('ReferrerTracker init error:', error)
    }
  },
}

export default ReferrerTracker
